import React from 'react';

/**
 * Full-width floating button for tablet & mobile
 * Fixed at bottom of screen, opens the order summary modal
 */
const FloatingOrderButton = ({ onClick }) => {
    return (
        <button
            className="floating-order-button"
            onClick={onClick}
            style={{
                backgroundColor: 'rgba(255, 124, 68)',
                color: 'white',
                border: 'none',
                borderRadius: '25px',
                padding: '14px 24px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
                e.target.style.backgroundColor = '#e66a2e';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.25)';
            }}
            onMouseOut={(e) => {
                e.target.style.backgroundColor = 'rgba(255, 124, 68)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
            }}
        >
            View Order Summary
        </button>
    );
};

export default FloatingOrderButton;
